import React from 'react';
import { NavMenu } from './components/MasterPage/NavMenu';
import { useMsal } from '@azure/msal-react';
import { EventType } from '@azure/msal-browser';
import { routes } from "./services/Routes";
import useFetchWithMsal from './services/useFetchWithMsal';
import { cookieHandler } from "./services/cookieHandler";
import { useNavigate, Routes, Route} from "react-router-dom";
import { SpheraNotFound, NavigationPanel, SpheraNoPermissions } from "@sphera-cloud/component-ui-reactjs";
import { apiRoutes } from './services/apiRoutes';
import { CustomerData } from './Data/CustomerData';

const Pages = (props) => {
	const { execute } = useFetchWithMsal({
		scopes: props.loginConfig.protectedResources.apiDocumentList.scopes.read,
	});
	let navigate = useNavigate();

	let { getLocalizations, getCustomerData, updateEntitlements } = CustomerData({ execute: execute, navigate });
	const props404 = {
		errorMessage: 'Sorry, the page you requested was not found.', supportEmail: 'customercare@sphera.com', buttonText: 'Go Back', onBackButtonClick: (event) => { navigate(-1); }
	}
	const props401 = {
		errorMessage: "It looks like you do not have permission to access this page/app.",
		subMessage: "To get access, contact your system administrator.",
		redirectMessage: "While you're waiting, check out the complete list of SpheraCloud solutions ",
		redirectLink: "https://sphera.com/spheracloud/",
		redirectLinkText: "here.",
	}
	
	const [propsSphera401, setpropsSphera401] = React.useState({
		errorMessage: "Hello Spherion!",
		subMessage: "It looks like you do not have permission to access Document Storage. To access Document Storage, select another customer on the SpheraCloud landing page:",
		redirectMessage: "1) Go to Landing Page. _______________________________________ 2) Select your customer from the list. ________________________ 3) Use the App Switcher enter your desired solution. ________ ",
		redirectLink: "",
		redirectLinkText: "The SpheraCloud Landing Page",
	});

	const { setCookie, getCookie, eraseCookie } = cookieHandler();
	let languageJSON = getCookie("sphdsLanguage");
	let language = { "localeId": 1033, "languageCode": "en-US", "language": "English - United States", "localizationValue": [] };
	if (languageJSON != null)
		language = JSON.parse(languageJSON);

	const { instance } = useMsal();
	let activeAccount;
	if (instance) {
		activeAccount = instance.getActiveAccount();
	}

	const [customer, setcustomer] = React.useState({});
    const [localizations, setlocalizations] = React.useState([]);
	const [products, setproducts] = React.useState({});
	const [currentTenent, setcurrentTenent] = React.useState({});
	const [portalBaseDomain, setPortalBaseDomain] = React.useState('');
	const [versionNumber, setversionNumber] = React.useState("");
	const [INIT_MENUS, setINIT_MENUS] = React.useState([]);
	const [languageValue, setlanguageValue] = React.useState(language);
	const [showPreferencesModal, setShowPreferencesModal] = React.useState(false);

	const preferencesHandler = (e) => {
		setShowPreferencesModal(!showPreferencesModal);
	};

	const config = React.useMemo(() => {
		return updateEntitlements(localizations, preferencesHandler, activeAccount, customer, products);
	}, [activeAccount, customer, localizations, navigate, products]);

	const updateDefaultSite = (siteId) => {
		let updatedCustomer = customer;
		updatedCustomer.defaultSite = siteId;
		setcustomer(updatedCustomer);
	}

	const getData = async (localeId) => {
		let { products, currentTenent, localizations, customer, INIT_MENUS, PortalBaseDomain, landingPageUrl } = await getCustomerData(localeId);
		setproducts(products);
		setcurrentTenent(currentTenent);
		setlocalizations(localizations);
		setcustomer(customer);
		setINIT_MENUS(INIT_MENUS);
		setPortalBaseDomain(PortalBaseDomain);
		let newpropsSphera401 = propsSphera401;
		newpropsSphera401.redirectLink = landingPageUrl;
		setpropsSphera401(newpropsSphera401);
	}

	const changeLanguage = async (newLanguage) => {
		eraseCookie("sphdsLanguage");
		setCookie("sphdsLanguage", JSON.stringify(newLanguage), 1);
		setlanguageValue(newLanguage);

		let { MENUS, newLocalizations, columns } = await getLocalizations(newLanguage.localeId, customer.columns.originalColumns);
		setlocalizations(newLocalizations);
		setINIT_MENUS(MENUS);
		let cust = customer;
		cust.columns = columns;
		setcustomer(cust);
	};

	React.useEffect(() => {
		if (versionNumber === "") {
			fetch(apiRoutes.documents.version, { method: "GET" }).then((response) => {
				response.json().then(json => {
					setversionNumber(json);
				});
			});
		}

		if (window.location.href.indexOf("NoPermissions") === -1)
			getData(languageValue.localeId);

		const callbackId = instance.addEventCallback((event) => {
			if (event.eventType === EventType.LOGIN_FAILURE) {
				console.log("login failed");
			}
		});

		return () => {
			if (callbackId) {
				instance.removeEventCallback(callbackId);
			}
		};
	}, [execute]);

	React.useEffect(() => {
		const itemKey = "msal.interaction.status";
		if (sessionStorage.getItem(itemKey)) {
		  sessionStorage.removeItem(itemKey);
		}
	  }, []);
	  

    return (
		<main>
			<NavMenu menuSettings={config}
					 localizations={localizations}
					 changeLanguage={changeLanguage}
					 languageValue={languageValue}
					 showPreferencesModal={showPreferencesModal}
					 togglePreferences={preferencesHandler}
					 />
			{(currentTenent != null && currentTenent.RequiresNavMenu) ? (
					<NavigationPanel
						allMenus={INIT_MENUS}
						lazyLoading={false}
						treeBased={true}
						reload={true}
						navigate={navigate}>
							<Routes>
								{routes.map(
									(route, idx) =>
										<Route key={idx} path={route.path} element={<route.type loginConfig={props.loginConfig}
											customer={customer} setcustomer={setcustomer} localizations={localizations} languageValue={languageValue}
											changeLanguage={changeLanguage}
											updateDefaultSite={updateDefaultSite}
											currentTenent={currentTenent}
											versionNumber={versionNumber}
											portalBaseDomain={portalBaseDomain} />}
										/>
								)}
								<Route path='/NoPermissions' element={<SpheraNoPermissions {...props401} />} />
								<Route path='/SpheraNoPermissions' element={<SpheraNoPermissions {...propsSphera401} />} />
								<Route path='*' element={<SpheraNotFound {...props404} />} />
							</Routes>	
				</NavigationPanel>):
					(<div>
							<Routes>
								{routes.map(
									(route, idx) =>
										<Route key={idx} path={route.path} element={<route.type loginConfig={props.loginConfig}
											customer={customer} setcustomer={setcustomer} localizations={localizations} languageValue={languageValue}
											changeLanguage={changeLanguage}
											updateDefaultSite={updateDefaultSite}
											currentTenent={currentTenent}
											versionNumber={versionNumber}
											portalBaseDomain={portalBaseDomain} />}
										/>
									)}
								<Route path='/NoPermissions' element={<SpheraNoPermissions {...props401} />} />
								<Route path='/SpheraNoPermissions' element={<SpheraNoPermissions {...propsSphera401} />} />
								<Route path='*' element={<SpheraNotFound {...props404} />} />
							</Routes>
					</div>)
				}
		</main>
    );
};

export function App(props) {
	const { instance } = useMsal();
	let activeAccount;

	if (instance)
		activeAccount = instance.getActiveAccount();

	if (activeAccount == null || (activeAccount.idTokenClaims.exp * 1000) < Date.now()) {
		props.instance.loginRedirect(props.loginConfig.loginRequest).catch((error) => console.log(error));
		return '';
	}

	return (
		<>
			<Pages loginConfig={props.loginConfig} />
		</>
	);
}
